import React from "react";
import { Button, Modal } from "react-bootstrap";

const SendSignupLinkModal = ({ signupModal, handleClose, sendSignupLink }) => {
  return (
    <Modal show={signupModal} onHide={() => handleClose()} backdrop={"static"}>
      <Modal.Header>
        <Modal.Title>Send Signup Link</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <p>Are you sure want to send a signup link to the patient?</p>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={handleClose}>
          Close
        </Button>
        <Button variant="primary" onClick={sendSignupLink}>
          yes
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default SendSignupLinkModal;
